import React from "react";

export default function Translate({fHead, content, btn,link, linkName , backgroundCol}) {
  return (
    <div className={`${backgroundCol ? backgroundCol :"bg-darkBlue "} flex items-center justify-center`}>
      <div className="main text-white text-center flex-col items-center justify-center md:w-5/12 w-11/12 py-20">
        <h2 className="text-4xl font-extrabold font-secondary">
          {" "}
          <span className="text-orange">{fHead ? fHead : "Professional"}</span> into Any Language
        </h2>
        <p className="font-light pt-16 pb-12 font-opensans">
         { content ? content : "Speak to the Tomedes team today for more information on the advantages of localization and what it can do for your company. Contact us for more information or you can chat with us via Whatsapp."}
        </p>
        
        {btn ? <div className="btn text-white max-w-max learnmore font-opensans text-lg flex-col mx-auto justify-center hover:text-orange pt-4">
                <a href={link ? link : "/"}>{linkName ? linkName : "GET STARTED"}</a>
                <div className="border-b bg-white"></div> {btn}
              </div> : null }
      </div>
      
    </div>
  );
}
